/**
 * Determines whether the app should reload based on version data.
 *
 * @param {Object} params
 * @param {string} params.currentVersion - The version baked into the running bundle
 * @param {string} params.remoteVersion - The version from the server's version.json
 * @param {boolean} params.isIdle - Whether the kiosk is in idle state
 * @param {boolean} params.isTouch - Whether the kiosk is a touch device
 * @param {number|null} params.lastReloadTime - Timestamp of last reload (from sessionStorage)
 * @param {number} params.now - Current timestamp
 * @returns {'reload'|'defer'|'skip'} - Action to take
 */
export const getVersionAction = ({ currentVersion, remoteVersion, isIdle, isTouch, lastReloadTime, now }) => {
	// Reload-loop guard: skip if reloaded within the last 60 seconds
	if (lastReloadTime && now - lastReloadTime < 60000) {
		return 'skip';
	}

	// No version to compare
	if (!currentVersion || !remoteVersion) {
		return 'skip';
	}

	// Versions match — no update needed
	if (currentVersion === remoteVersion) {
		return 'skip';
	}

	// Version mismatch detected — decide when to reload
	if (isIdle || isTouch === false) {
		return 'reload';
	}

	return 'defer';
};
